import React from 'react';
import Notification from './Notification';
import { FaRegUserCircle } from 'react-icons/fa';
import { GrCalculator } from 'react-icons/gr';
import '../css/custom.css';
import 'bulma-divider/dist/css/bulma-divider.min.css';

export default function CustomerCard(props) {
   let { customer } = props;
   const renderContent = () => {
      if (customer.responseCode === 1) {
         return (
            <>
               <div className='subtitle is-6 mb-3'>
                  <span>
                     <FaRegUserCircle />
                  </span>{' '}
                  Customer Names : {customer.firstName} {customer.lastName}
               </div>
               {/* <br /> */}
               <div className='subtitle is-6 mb-3'>
                  <span>
                     <GrCalculator />
                  </span>
                  {'  '}Meter Number : {customer.meterNumber}
               </div>
               {/* <br /> */}
               <div className='subtitle is-6 mb-3'>
                  <span>Minimum Amount : {customer.minAmount} FRW</span>
               </div>
               <div className='subtitle is-6 mb-3'>
                  <span>Maximum Amount : {customer.maxAmount} FRW</span>
               </div>
            </>
         );
      } else return <Notification notificationType='danger' notification={customer.responseDesc} />;
   };

   return (
      <div className='card'>
         <header className='card-header'>
            <p className='card-header-title'>Customer Details</p>
            <a href='#1' className='card-header-icon' aria-label='more options'>
               <span className='icon'>
                  <i className='fas fa-angle-down' aria-hidden='true'></i>
               </span>
            </a>
         </header>
         <div className='card-content'>
            <div className='content'>{renderContent()}</div>
         </div>
      </div>
   );
}

// export const EnhancedCustomerCard = withComponentWrapper(CustomerCard);
